import React, { Component } from "react";
import { pmaActions } from "_store/_actions";
import { connect } from "react-redux";
import { CircularProgress } from '@mui/material';

class LocalEventsOrganizations extends Component {
  componentDidMount = () => {
    const { altAgentData } = this.props;
    const { pmaScheduleID, pmaMarketID } = altAgentData;
    const { mlsCityID } = this.props.currentArea;
    this.props.getLocalEventsDetails(pmaScheduleID, pmaMarketID, mlsCityID);
  };
  render() {
    const {
      selectEventText,
      selectedQuadrantNumber,
      localEventsList,
      editQuadrantFormData,
    } = this.props;
    const { defaultLocalEventList } = localEventsList;
    if (defaultLocalEventList && defaultLocalEventList.length >= 1) {
      return (
        <div className="local-events-organizations">
          <div className="local-events-organizations-title">
            <p>You can select from additional events below:</p>
          </div>
          <div className="local-events-organizations-list-container">
            {defaultLocalEventList.map((organization) => {
              let buttonText = "Select This Event";
              let buttonStyles;
              let quadrantTitle =
                editQuadrantFormData[
                  `localEventHeader${selectedQuadrantNumber}`
                ];
              let quadrantText =
                editQuadrantFormData[`localEventText${selectedQuadrantNumber}`];
              let quadrantWebsiteURL =
                editQuadrantFormData[
                  `localEventFooter${selectedQuadrantNumber}`
                ];
              if (
                quadrantTitle === organization.localEventHeader &&
                quadrantText === organization.localEventText &&
                quadrantWebsiteURL === organization.localEventFooter
              ) {
                buttonText = "Selected";
                buttonStyles = "selected-organization-btn";
              }
              return (
                <div
                  className="organization-section"
                  key={organization.localEventID}
                >
                  <div className="organization-section-button-container">
                    <div
                      className={`organization-section-button ${buttonStyles}`}
                    >
                      <p
                        className="organization-section-button-text"
                        onClick={() =>
                          selectEventText(organization, selectedQuadrantNumber)
                        }
                      >
                        {buttonText}
                      </p>
                    </div>
                  </div>
                  <div className="organization-section-content-container">
                    <p className="organization-section-inner-content">
                      <span className="organization-list-text">
                        <strong>{organization.localEventHeader}</strong>
                        {organization.localEventText}{" "}
                        <span className="organization-list-websiteURL">
                          {organization.localEventFooter}
                        </span>
                      </span>
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      );
    } else {
      return (
        <div className="local-events-loading-container">
          <CircularProgress />
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    localEventsList: state.pma.localEventsList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getLocalEventsDetails: (pmaScheduleID, pmaMarketID, cityID) => {
      dispatch(
        pmaActions.getLocalEventsDetails(pmaScheduleID, pmaMarketID, cityID)
      );
    },
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LocalEventsOrganizations);
